import React from 'react';
import { useTheme } from '../components/ThemeContext';

export const PrivacyPolicy: React.FC = () => {
  const { theme } = useTheme();
  const textCls = theme === 'dark' ? 'text-theme-secondary' : 'text-gray-800';
  const subCls = theme === 'dark' ? 'text-theme-muted' : 'text-gray-600';
  const hCls = theme === 'dark' ? 'text-theme-primary' : 'text-gray-900';

  return (
    <main className={`max-w-3xl mx-auto px-4 md:px-6 py-6 md:py-10 ${textCls}`}>
      <h1 className={`text-3xl font-bold mb-2 ${hCls}`}>Privacy Policy</h1>
      <p className={`${subCls} text-sm mb-8`}>Last Updated and Effective: {new Date().getFullYear()}</p>

      <section className="space-y-6">
        <p>
          Stock Fortress, Inc ("we," "us," or "Stock Fortress") cares about protecting the personal information of our
          customers and visitors (collectively, our "Users") who use our website at stockfortress.com and any
          subdomains (collectively the "Site"), or other products and services (including any related mobile applications)
          provided to you by us (collectively along with the Site, the "Services"). This privacy policy provides details
          about how your personal information is collected, shared and used by us, and your choices regarding your
          information. If you have any questions about this privacy policy or the practices described herein, you may
          contact us at <a className="underline" href="mailto:support@stockfortress.com">support@stockfortress.com</a>.
        </p>

        <h2 className={`text-xl font-semibold ${hCls}`}>Information Covered By This Privacy Policy</h2>
        <p>
          This privacy policy covers personal information, including any information we collect, use and share from you,
          as described further below. This privacy policy applies to all of our Services. This privacy policy does not
          cover how our Users may use or share data that they collect using our Services.
        </p>

        <h2 className={`text-xl font-semibold ${hCls}`}>Information We Collect</h2>
        <p>
          We collect information from you in the ways outlined below. By voluntarily providing us with personal
          information, you consent to our use of it in accordance with this privacy policy and acknowledge and agree that
          such personal information may be transferred from your current location to our servers and the authorized
          third parties referred to herein.
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Information you give us (e.g., name, username, password, email address, mailing address, mobile number, billing or payment information).</li>
          <li>Information we receive from others (e.g., analytics providers and advertising partners).</li>
          <li>Information collected from your use of the Services (e.g., IP address, device identifiers, browser information, page view statistics, usage information, transaction information, cookies and similar technologies, location information, and log data).</li>
        </ul>

        <h2 className={`text-xl font-semibold ${hCls}`}>How We Use Information</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Provide, operate and maintain the Services.</li>
          <li>Improve, personalize, and expand the Services.</li>
          <li>Understand and analyze how you use the Services.</li>
          <li>Develop new products, services, features, and functionality.</li>
          <li>Communicate with you, including for customer service, updates, and marketing.</li>
          <li>Process transactions and prevent fraud.</li>
          <li>Comply with legal obligations.</li>
        </ul>

        <h2 className={`text-xl font-semibold ${hCls}`}>Sharing Of Information</h2>
        <p>
          We may share personal information with service providers, analytics and advertising partners, within our
          corporate family, and as required by law. We do not sell your personal information.
        </p>

        <h2 className={`text-xl font-semibold ${hCls}`}>Cookies And Tracking Technologies</h2>
        <p>
          We and our partners use cookies and similar tracking technologies to track activity on the Services and hold
          certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being
          sent. For more information about cookies, please refer to your browser settings.
        </p>

        <h2 className={`text-xl font-semibold ${hCls}`}>Data Retention</h2>
        <p>
          We retain personal information for as long as necessary to provide the Services, comply with our legal
          obligations, resolve disputes, and enforce our agreements.
        </p>

        <h2 className={`text-xl font-semibold ${hCls}`}>Your Choices</h2>
        <p>
          You may access, update, or delete certain personal information within your account settings. You can opt out of
          marketing emails by following the unsubscribe instructions in those messages. If you have questions or requests
          regarding your data, contact us at <a className="underline" href="mailto:support@stockfortress.com">support@stockfortress.com</a>.
        </p>

        <h2 className={`text-xl font-semibold ${hCls}`}>Children's Privacy</h2>
        <p>
          Our Services are not directed to individuals under the age of 18, and we do not knowingly collect personal
          information from children under 18.
        </p>

        <h2 className={`text-xl font-semibold ${hCls}`}>Changes To This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. We will post the updated policy on this page and update
          the "Last Updated" date above.
        </p>
      </section>
    </main>
  );
};

export default PrivacyPolicy;
